module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAS1BMVEUAAADMzMzNzc3Ozs7Pz8/R0dHS0tLT09PU1NTY2NjZ2dnc3Nzd3d3e3t7h4eHj4+Pk5OTs7Ozt7e3u7u7v7+/6+vr7+/v9/f3+/v41YJ2OAAAAAXRSTlMAQObYZgAAAIVJREFUGNNtke0WgyAIhnmz1Jx9aW3e/5UuFTu18f4QeA4IIlFWipNVyk4x0aVowDI7o7TgprXCGfijET86b/gM2elrXIxOtJXgGLNxR6GBXiXFvUc+TnnSaLQxWOrQaGPo79Cxqx7lTM2zkeNG4kji8BSEZ8oLkVcnLjknB29Vp32o3/EFjaAGvHlACyEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/delete.png
// module id = 606
// module chunks = 0